import { Dsec } from '../utils';

class ExtState {
    import(state, props, args) {
        if ((args || []).length) {
            args.forEach((name) => {
                if (Dsec.isset(props[name])) {
                    state[name] = props[name];
                }
            });
        } else {
            for (let name in props) {
                state[name] = props[name];
            }
        }
    }

    export(state, args) {
        if ((args || []).length) {
            let output = {};
            args.forEach((name) => {
                if (Dsec.isset(state[name])) {
                    output[name] = state[name];
                }
            });
            return output;
        } else {
            return state;
        }
    }
}

export default new ExtState();